/**
 * 滚动加载数据类
 */
var ScrollLoad = /*#__PURE__*/function () {
  /**
   * 构造函数
   * @param  {[type]}   selector 选择器对象
   * @param  {Function} callback 加载数据回掉函数
   * @return {[type]}            [description]
   */
  function ScrollLoad(selector, callback) {
    this.selector = selector;

    this.callback = callback || function () {
      return Promise.all([]);
    };

    this.lastScrollTop = 0; // 上一次滚动条所在的位置

    return this;
  }

  /**
   * 实例化方法
   * @param  {[type]}   selector [description]
   * @param  {Function} callback  [description]
   * @return {[type]}             [description]
   */
  ScrollLoad.init = function init(selector, callback) {
    return new this(selector, callback);
  }
  /**
   * 初始化绑定滚动事件
   * @return {[type]} [description]
   */
  ;

  var _proto = ScrollLoad.prototype;

  _proto.initEvent = function initEvent() {
    var selector = this.selector; // 获取元素

    var elem = document.querySelector(selector.name); // 判断elem是否为空

    if (elem && this.elem !== elem) {
      // 当前元素状态变更为已绑定
      selector.status = true; // 绑定scroll事件

      elem.addEventListener('scroll', this.loadEvent.bind(this)); // 赋值到属性

      this.elem = elem;
    }

    return this;
  }
  /**
   *
   * [loadEvent description]
   *  @return {[type]} [description]
   */
  ;

  _proto.loadEvent = function loadEvent(e) {
    var selector = this.selector; // 当前滚动对象

    var elem = e.target; // 当前滚动的位置

    var scrollTop = elem.scrollTop; // 方向

    var delta = scrollTop > this.lastScrollTop; // 上一次的位置

    this.lastScrollTop = scrollTop; // 判断是否滚动到底

    if (delta && scrollTop + elem.offsetHeight + 15 > elem.scrollHeight && !selector.isLock) {
      // 锁定加载
      selector.isLock = true; // 加载进度条

      var cancelLoad = this.createLoadBar(elem); // 进行数据拉取

      if (cancelLoad) {
        this.callback().then(function (res) {
          // 加载锁定去除
          selector.isLock = false; // 移除元素

          cancelLoad();
        });
      }
    }
  }
  /**
   * 创建loading进度条
   * @param  {[type]} elem [description]
   * @return {[type]}      [description]
   */
  // eslint-disable-next-line class-methods-use-this
  ;

  _proto.createLoadBar = function createLoadBar(elem) {
    // 获取表tbody
    var tbody = elem.querySelector('tbody');

    try {
      if (tbody) {
        // 第一个tr
        var ftr = tbody.querySelector('tr');

        if (ftr) {
          // td数量
          var len = ftr.querySelectorAll('td').length; // 创建tr与td

          var tr = document.createElement('tr');
          var td = document.createElement('td'); // 设置属性

          td.setAttribute('colspan', len);
          td.style.textAlign = 'center'; // 增加加载中元素

          var span = document.createElement('span');
          span.className = 'ant-spin-dot ant-spin-dot-spin';
          span.innerHTML = '<i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i>'; // 加载tr到中

          td.appendChild(span);
          tr.appendChild(td); // tr加载到tbody中

          tbody.appendChild(tr);
          return function () {
            tbody.removeChild(tr);
          };
        } else {
          // eslint-disable-next-line no-throw-literal
          throw 'not find tr';
        }
      } else {
        // eslint-disable-next-line no-throw-literal
        throw 'not find tbody';
      }
    } catch (e) {
      // 不存在table时
      // 创建div容器
      var div = document.createElement('div'); // 居中

      div.style.textAlign = 'center'; // 增加加载中元素

      var _span = document.createElement('span');

      _span.className = 'ant-spin-dot ant-spin-dot-spin';
      _span.innerHTML = '<i></i><i></i><i></i><i></i>'; // 加载tr到中

      div.appendChild(_span);
      elem.appendChild(div);
      return function () {
        elem.removeChild(div);
      };
    }
  }
  /**
   * 重置为初始属性
   * @return {[type]} [description]
   */
  ;

  _proto.reset = function reset() {
    this.selector.status = false;
    this.selector.isLock = false;
    this.lastScrollTop = 0;

    this.callback = function (e) {
      return Promise.all([]);
    };
  }
  /**
   * 销毁事件监听
   * @return {[type]} [description]
   */
  ;

  _proto.destory = function destory() {
    this.reset(); // 绑定scroll事件

    if (this.elem) {
      this.elem.removeEventListener('scroll', this.loadEvent.bind(this));
    }
  };

  return ScrollLoad;
}();

export { ScrollLoad as default };